/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import BaseControl from 'scripts/base-control';
import scheduleDataView from './tv-schedule.stache';
import 'components/right-rail/tv-schedule/tv-schedule';

export const RightRailTvSchedule = BaseControl.extend({
    init: function () {
        this._super();

        if (this.options.events && this.options.events.length) {
            this.$element
                .prepend(scheduleDataView({
                    events: this.options.events,
                    date: this.options.date
                }));
        }
    }
});
